<template>
    <div class="chip px-3 secondary">
        <span><slot /></span>
    </div>
</template>

<script>
export default {};
</script>

<style scoped>
.chip {
    min-height: 32px;
    opacity: 0.7;
    color: white;
    border-radius: 16px;
    text-transform: none !important;

    display: inline-flex;
    vertical-align: middle;
    justify-content: center;
    align-items: center;
    flex-basis: 0;
}
</style>
